import curd from '../curd'

const BASE_PATH = '/factor'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Factor.js